
//////////////////////////////////////////////////////  GLOBAL VARIABLES ////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////// FUNCTIONS DEFINITIONS //////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////// GRAB THE RELEVANT HTML PAGE ELEMENTS /////////////////////////////////////////////////////

function grabHtmlContentForLangTranslate() {

	return {
		els2BeTranslated_a: document.querySelectorAll('[lang]'),
	}
}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



/////////////////////////// CHANGE LANGUAGE IN HTML TEXT ELEMENTS BASED ON LANG SELECTION //////////////////////////////
function replaceLang(langSelected) {
	
	const {els2BeTranslated_a} = grabHtmlContentForLangTranslate();
	console.log(els2BeTranslated_a);
	
	if (!els2BeTranslated_a) return;

if (langSelected ==='italian')
{
	for (const el of els2BeTranslated_a)
	{
		if (el.getAttribute('lang') !== 'it' && el.getAttribute('lang') !=='it_flex')
			{el.style.display = 'none';}
		else
			{//el.style.display = 'initial';
			el.style.display = 'block';
			el.style.animationName = "none";
			el.style.backgroundColor = "initial";
			el.style.backgroundColor = "revert-layer";
		
			if (el.tagName === 'SPAN')
				{el.style.display = "inline";}
			
			if (el.tagName === 'INPUT')
				{el.style.backgroundColor = "revert-layer";
				el.style.display = "inline";}
			
			if (el.getAttribute('lang') === 'it_flex')
				{el.style.display = 'flex';}
		
		}
	
	}
} 

else if (langSelected ==='english')
{
	
	for (const el of els2BeTranslated_a)
	{
		if (el.getAttribute('lang') !== 'en' && el.getAttribute('lang') !== 'en_flex')
			{el.style.display = 'none';}
		else
		{//el.style.display = 'initial';
		el.style.display = 'block';
		el.style.animationName = "none";
		el.style.backgroundColor = "initial";
		el.style.backgroundColor = "revert-layer";
		
		if (el.tagName === 'SPAN')
			{el.style.display = "inline";}
		
		if (el.tagName === 'INPUT')
			{el.style.backgroundColor = "revert-layer";
			el.style.display = "inline";}
		
		if (el.getAttribute('lang') === 'en_flex')
			{el.style.display = 'flex';}	

	}
	
	}
	
} 

else if (langSelected ==='french')
{
	
	for (const el of els2BeTranslated_a)
	{
		if (el.getAttribute('lang') !== 'fr' && el.getAttribute('lang') !== 'fr_flex')
			{el.style.display = 'none';}
		else
			{//el.style.display = 'initial';
			el.style.display = 'block';
			el.style.animationName = "none";
			el.style.backgroundColor = "initial";
			el.style.backgroundColor = "revert-layer";
			
			if (el.tagName === 'SPAN')
				{el.style.display = "inline";}
			
			if (el.tagName === 'INPUT')
				{el.style.backgroundColor = "revert-layer";
				el.style.display = "inline";}
			
			if (el.getAttribute('lang') === 'fr_flex')
				{el.style.display = 'flex';}	

		}
	
	}
} 

else if (langSelected ==='german')
{
	for (const el of els2BeTranslated_a)
	{
		if (el.getAttribute('lang') !== 'de' || el.getAttribute('lang') !== 'de_flex')
			{el.style.display = 'none';}
		else
		{//el.style.display = 'initial';
	el.style.display = 'block';
	el.style.animationName = "none";
	el.style.backgroundColor = "initial";
	el.style.backgroundColor = "revert-layer";
	
	if (el.tagName === 'SPAN')
	{el.style.display = "inline";}
	
	if (el.tagName === 'INPUT')
	{el.style.backgroundColor ="#E37383";
	el.style.backgroundColor = "revert-layer";
	el.style.display = "inline";}
	
	if (el.getAttribute('lang') === 'de_flex')
	{el.style.display = 'flex';}	

	}
	
	}
}

console.log(langSelected);

}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////	EVENT HANDLERS /////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////// HANDLER FOR LANGUAGE SELECTOR BUTTON PRESSED EVENT /////////////////////////////

document.addEventListener('DOMContentLoaded', () => {
	
//START OF "On page load, change the language according to the language selected in previous pages"
const selectedLang = localStorage.getItem("langSelected");

replaceLang(selectedLang);
//END OF "On page load, change the language according to the language selected in previous pages"

//START OF "Listen for language change over all document"
	SiteApp.eventBus.on("language:change", (selectedLang) => {
			replaceLang(selectedLang);
		})
//END OF "Listen for language change over all document"
		
		})

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////